import {Button, Typography} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages';
import React from 'react';
import {ModalErrorProps} from './types';

export function ModalError({
	open,
	onClose,
	headerTitle,
	title,
	description,
	subDescription,
	firstButton,
	secondButton,
	isFullScreen,
	maxWidth,
	disableClose = false,
	disabled,
}: ModalErrorProps) {
	const {isTablet} = useMediaQueries();
	const fullScreen = isFullScreen !== undefined ? isFullScreen : isTablet;

	return (
		<Modal.Root
			open={open}
			onClose={onClose}
			fullScreen={fullScreen}
			slotProps={{paper: {style: {maxWidth}}}}>
			<Modal.Header onClose={onClose} title={headerTitle} disableClose={disableClose} />
			<Modal.Content
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: 2,
				}}>
				<IconIllustration variant="info" />
				<Typography variant="h6" textAlign="center">
					{title}
				</Typography>
				{description ? (
					<Typography variant="body1" textAlign="center">
						{description}
						{subDescription ? (
							<Typography variant="body1" textAlign="center">
								{subDescription}
							</Typography>
						) : null}
					</Typography>
				) : null}
			</Modal.Content>
			<Modal.Footer sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
				{firstButton ? (
					<Button
						disabled={disabled}
						size="large"
						variant={firstButton.variant || 'contained'}
						fullWidth
						endIcon={firstButton.endIcon}
						onClick={firstButton.handleClick}>
						{firstButton.title}
					</Button>
				) : null}
				{secondButton ? (
					<Button
						size="large"
						variant={secondButton.variant || 'outlined'}
						fullWidth
						onClick={secondButton.handleClick}>
						{secondButton.title}
					</Button>
				) : null}
			</Modal.Footer>
		</Modal.Root>
	);
}
